module.exports = __webpack_public_path__ + "static/media/image14.a8eee461.jpg";